import script from "./object_dayCollectionCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./object_dayCollectionCourse.vue?vue&type=script&setup=true&lang=js"

import "./object_dayCollectionCourse.vue?vue&type=style&index=0&id=39234796&lang=css&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39234796"]])

export default __exports__